if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.formSubmitSelector = this.dataset.formSubmitSelector;
      this.submitButton = this.querySelector(`.${this.formSubmitSelector}`);
      this.initialValue = this.querySelector('input[name="country_code"]').value;

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        select: this.querySelector('select'),
        selectOptions: this.querySelectorAll('select option')
      };
    }

    connectedCallback() {
      if (this.submitButton) {
        this.submitButton.addEventListener('click', this.onSubmit.bind(this));
        this.elements.select.addEventListener('change', this.updateInputValue.bind(this));
      } else {
        this.elements.select.addEventListener('change', this.onSelectChange.bind(this));
      }
    }

    updateInputValue(event) {
      this.elements.input.value = event.currentTarget.value;
    }

    onSelectChange(event) {
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.value;
      if (form) form.submit();
    }

    onSubmit(event) {
      event.preventDefault();
      if(this.elements.select.value !== this.initialValue) {
        this.elements.select.value = this.elements.input.value;
        const form = this.querySelector('form');
        if (form) form.submit();
      } else {
        console.log('No changes')
      }
    }
  });
}